export default __webpack_public_path__ + "static/media/checkimg.8e575153.svg";